import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";
import { toast } from 'react-toastify';
import { getUserFromToken } from "../utils/utility";

export const listConfigurations = (requestPayload, listFormKey, configLocationPath = 'configurations') => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, configLocationPath == "configurations" ? "listConfiguration" : "listMasterConfiguration", "configurations");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.CONFIGURATION.CONFIGURATION_LIST,
                payload: { [configLocationPath]: listJson },
            });
        }
    } catch (error) {
        console.log(error);
    }
};

const formListJson = (formPayload, listPayload) => {
    const { data = {}, meta = {} } = formPayload;
    const { configurations = [], meta: listMeta = {} } = listPayload;
    const { users: userMeta = {} } = listMeta;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = configurations.map(configuration => {
        const { type = '', data = {}, userId = '' } = configuration;
        const { title = '', firstName = '', lastName = '', } = userMeta[userId] || {};
        const { apiKey = ' ' } = data;
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case "apiKey": {
                    value = apiKey;
                    break;
                }
                case "user": {
                    value = `${title ? title + ". " : ""} ${firstName} ${lastName} (${userId})`;
                    break;
                }
                case "action": {
                    if (type === "STRATEGY_ANALYSIS" || type === 'CRON_JOB')
                        value = ["edit", "delete", "run", "copy"];
                    else if (type === 'ZERODHA')
                        value = ["edit", "delete", "run"];
                    else
                        value = ["edit", "delete", "copy"];
                    break;
                }
                default: value = configuration[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const enableConfiguration = (requestPayload, configLocationPath = 'configurations') => {
    try {
        return async (dispatch, getState) => {
            const { configurationId = '', enabled = false } = requestPayload;
            const options = {
                api: configLocationPath == "configurations" ? "enableConfiguration" : "enableMasterConfiguration",
                urlAppend: `/${configurationId}/${enabled}`
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            const { configuration = {} } = getState();
            const { listing = {} } = configuration;
            const actualData = listing[configLocationPath] || {};
            const { data = [] } = actualData;
            const updatedData = data.map(datum => {
                if (datum.configurationId == requestPayload.configurationId)
                    return { ...datum, ...requestPayload };
                return datum;
            });
            if (success) {
                toast.success('Successfully Updated');
                return dispatch({
                    type: actionTypes.CONFIGURATION.CONFIGURATION_LIST,
                    payload: {
                        ...listing,
                        [configLocationPath]: {
                            ...actualData,
                            data: updatedData
                        }
                    },
                });
            } else {
                toast.error('Updation failed');
                return dispatch({ type: '', payload: {} });
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const deleteConfiguration = (requestPayload, configLocationPath = 'configurations') => {
    try {
        return async (dispatch, getState) => {
            const { configurationId = '' } = requestPayload;
            const options = {
                api: configLocationPath == "configurations" ? "deleteConfiguration" : "deleteMasterConfiguration",
                urlAppend: `/${configurationId}`
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            const { configuration = {} } = getState();
            const { listing = {} } = configuration;
            const actualData = listing[configLocationPath] || {};
            const { data = [] } = actualData;
            const updatedData = data.filter(datum => {
                return datum.configurationId != requestPayload.configurationId;
            });
            if (success) {
                toast.success('Successfully Deleted');
                return dispatch({
                    type: actionTypes.CONFIGURATION.CONFIGURATION_LIST,
                    payload: {
                        ...listing,
                        [configLocationPath]: {
                            ...actualData,
                            data: updatedData
                        }
                    },
                });
            } else {
                toast.error('Deletion failed');
                return dispatch({ type: '', payload: {} });
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const getConfiguration = (requestPayload, configLocationPath = 'configurations') => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: configLocationPath == "configurations" ? 'listConfiguration' : "listMasterConfiguration",
                content: requestPayload
            };
            const response = await ExternalApiRequest(options);
            const { payload = {} } = response;
            const { configurations = [] } = payload;
            const [firstConfiguration = {}] = configurations;
            return dispatch({
                type: actionTypes.CONFIGURATION.GET_CONFIGURATION_SUCCESS,
                payload: firstConfiguration,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const saveConfiguration = (requestPayload, configLocationPath = 'configurations') => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: configLocationPath == "configurations" ? 'saveConfiguration' : "saveMasterConfiguration",
                content: requestPayload
            };
            const response = await ExternalApiRequest(options);
            const { payload = {} } = response;
            return dispatch({
                type: actionTypes.CONFIGURATION.SAVE_CONFIGURATION_SUCCESS,
                payload,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const clearCacheData = () => {
    try {
        return async (dispatch, getState) => {
            dispatch({
                type: actionTypes.CONFIGURATION.SAVE_CONFIGURATION_SUCCESS,
                payload: {},
            });
            dispatch({
                type: actionTypes.CONFIGURATION.CONFIGURATION_LIST,
                payload: {},
            });
            return dispatch({
                type: actionTypes.CONFIGURATION.GET_CONFIGURATION_SUCCESS,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const runCronJob = (configurationId) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: 'runCronJob',
                content: {
                    id: configurationId
                }
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            if (success) {
                toast.success('Run Job completed');
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const getZerodhaConfig = () => {
    try {
        return async (dispatch, getState) => {
            const userInfo = getUserFromToken();
            const options = {
                api: 'listConfiguration',
                content: {
                    type: 'ZERODHA'
                }
            };
            const response = await ExternalApiRequest(options);
            const { status = {}, payload = {} } = response;
            const { configurations = [] } = payload;
            const { userId = '' } = userInfo;
            const filteredConfiguration = configurations.filter(config => config.userId === userId);
            const [firstConfig = {}] = filteredConfiguration;
            return dispatch({
                type: actionTypes.CONFIGURATION.ZERODHA_LOGIN_CONFIG,
                payload: firstConfig,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const updateZerodhaConfig = (content) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: 'saveConfiguration',
                content
            };
            const response = await ExternalApiRequest(options);
            return dispatch({
                type: actionTypes.CONFIGURATION.ZERODHA_SAVE_CONFIG,
                payload: response,
            });
        }
    } catch (error) {
        console.log(error);
    }
}